import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import ar from './locales/ar.json'

/** Languages the app ships. Arabic is right-to-left. */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
] as const

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]['code']

export function directionFor(language: string): 'ltr' | 'rtl' {
  return SUPPORTED_LANGUAGES.find((entry) => entry.code === language)?.dir ?? 'ltr'
}

/**
 * Sets `lang` and `dir` on <html>.
 *
 * Direction lives on the document rather than on a React context because Tailwind's
 * logical properties (`ps-*`, `me-*`, `start-*`) and the `[dir='rtl']` rules in the
 * stylesheet key off the attribute — so one assignment mirrors the entire UI.
 */
export function applyLanguage(language: string) {
  document.documentElement.lang = language
  document.documentElement.dir = directionFor(language)
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((entry) => entry.code),
    interpolation: {
      // React already escapes rendered values; double-escaping mangles apostrophes.
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'hrms-language',
    },
  })

i18n.on('languageChanged', applyLanguage)
applyLanguage(i18n.language)

export default i18n
